




























// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';

// primeface
import RadioButton from 'primevue/radiobutton';

export default defineComponent({
    components: {
        RadioButton,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        mapbox: {
            type: Object,
            default: null,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // refs
        const fillValue = ref('on');

        // methods
        const changeFillValue = () => {
            // props.geoRecord.isFill = fillValue.value === 'on' ? true : false;
            props.handleGeoRecordPropertyUpdate({isFill: fillValue.value === 'on' ? true : false})
        };

        // lifecycle
        onMounted(() => {
            if (props.geoRecord.id !== undefined) {
                fillValue.value = props.geoRecord.isFill ? 'on' : 'off';
            } else {
                changeFillValue();
            }
        });

        return { fillValue, changeFillValue };
    },
});
